﻿import SwitchSchool from "../../components/SwitchSchools/SwitchSchool.js";

class SwitchSchoolsMenu {
    constructor(modalId, loader, urlGetConnectionsForSchoolSwitcher, urlGetSwitchSchoolForm, urlGetSchoolsList) {

        this.modalId = modalId;
        this.loader = loader;
        this.urlGetConnectionsForSchoolSwitcher = urlGetConnectionsForSchoolSwitcher;
        this.urlGetSwitchSchoolForm = urlGetSwitchSchoolForm;
        this.urlGetSchoolsList = urlGetSchoolsList;

        this.init();
    }

    init() {
        let schoolConnectionsSwitcher = new SwitchSchool(this.modalId, this.loader,
            this.urlGetConnectionsForSchoolSwitcher,
            this.urlGetSwitchSchoolForm, this.urlGetSchoolsList);
        schoolConnectionsSwitcher.init();

    }
}

let switchSchoolsMenu = new SwitchSchoolsMenu(switchSchoolModalId, switchSchoolLoader, urlGetConnectionsForSchoolSwitcher,
    urlGetSwitchSchoolForm, urlGetSchoolsList);